import { BaseContainer } from './BaseContainer';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const DealsSvg = () => {
  return /*#__PURE__*/_jsx(BaseContainer, {
    $svgSize: '60%',
    children: /*#__PURE__*/_jsx(DealsIcon, {})
  });
};